<script lang="ts">
    export let src: string;
    export let srcset: string = '';
    export let width: number;
    export let height: number;
    export let description = '';

    let landscape = width > height; // On a landscape img the caption is always under the picture.
    let clientHeight = 0;
</script>

<section class="grid place-content-stretch justify-items-center lg:max-h-[80vh]">
    <figure
        class={`flex flex-col h-full gap-1 text-center lg:max-w-[90vw]  ${
            landscape ? '' : 'lg:flex-row justify-center w-full'
        }`}
    >
        <img
            class={`w-full shrink object-contain md:w-auto lg:max-h-[80vh] ${
                landscape ? 'md:w-full' : 'h-full min-w-max'
            }`}
            {src}
            {srcset}
            {width}
            {height}
            alt={description}
            loading="lazy"
            style:height={landscape && description
                ? `calc(min(100%, 80vh) - calc(${clientHeight}px + 0.25rem))`
                : '100%'}
        />
        {#if description}
            <figcaption
                bind:clientHeight
                class={`max-h-[80vh] text-center text-xs leading-3 ${
                    landscape ? '' : 'lg:py-5 lg:writing-mode-bt'
                }`}
            >
                {description}
            </figcaption>
        {/if}
    </figure>
</section>

<style>
    section {
        grid-column: full;
    }
</style>
